import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatAmount } from "../../utils/format";
import { secureGet } from "../../config/api";
import SnackbarNotification from '../../components/SnackbarNotification';

import xIcon from "../../icons/x.svg";
import noImage from '../../icons/noImageIcon.svg';

const ProductPopup = ({ productId, onClose }) => {
  const [activeTab, setActiveTab] = useState("details");
  const [product, setProduct] = useState({});
  const { t } = useTranslation();

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const showSnackbar = (message, severity = 'success', manual = false) => {
    setSnackbar({ open: true, message, severity, manual });
  };

  useEffect(() => {
    if (!productId) return;

    const abortController = new AbortController();
    const fetchProduct = async () => {
      try {
        const product = await secureGet(`/products/${productId}`, showSnackbar, { signal: abortController.signal });
        setProduct(product.data);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error("Error fetching product:", error);
        }
      }
    };

    fetchProduct();
    return () => {
      abortController.abort();
    };
  }, [productId]);

  if (!productId) return null;

  const { image, name, priceTTC, reference, availability, familyName, discount, family } = product;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleImageError = (e) => {
    e.target.src = noImage;
    e.target.style.width = "50px";
    e.target.style.height = "50px";
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1050]">
      <div className="bg-[#F9FAFC] shadow-[0px_20px_80px_#00000011] rounded-lg w-[1052px] h-[550px] flex p-4 relative items-center">
        <button
          onClick={() => {
            onClose();
          }}
          className="absolute top-2 right-2 bg-[#FAFAFA] rounded-[24px] p-[5px]"
        >
          <img src={xIcon} alt={name} className="" />
        </button>
        <div
          className="flex items-center shadow-[0px_6px_26px_rgba(98,107,125,0.07)] bg-white justify-center overflow-hidden rounded-md z-10"
          style={{
            width: "45%",
            height: "98%",
            flexShrink: 0,
          }}
        >
          <img
            src={image}
            alt={name}
            className="object-contain w-full h-full"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
            }}
            onError={handleImageError
            }
          />
        </div>

        <div className="flex-1  overflow-hidden">
          <div className=" bg-white pl-8 pt-4 shadow-[0px_6px_26px_rgba(98,107,125,0.07)] pb-4">
            <div
              className=" text-white  text-[16px] font-semibold py-1 px-4 rounded-full inline-block mb-4"
              style={{ backgroundColor: family?.color }}
            >
              {familyName}
            </div>
            <h2 className="text-[26px] font-semibold text-gray-800">{name}</h2>
            <p className="text-[38px] font-bold text-primary">{formatAmount(priceTTC)}
            </p>
            <div className="mt-4 flex items-center gap-8">
              <div className="flex items-center">
                <span className="text-[12px] font-semibold text-[#707070] mr-2">{t(`rows.discountApplied`)}:</span>
                <span className="text-[#020040] text-[20px] font-semibold">{discount || "0.00"}%</span>
              </div>
              <div className="flex items-center">
                <span className="text-[12px] font-semibold text-[#707070] mr-2">{t(`rows.reference`)}:</span>
                <span className="text-[#020040] text-[20px] font-semibold">{reference}</span>
              </div>
            </div>
          </div>


          <div className="overflow-y-auto h-[240px]">
            <div className="mt-0 mb-4 pl-8">
              {availability && availability.length > 0 ? (
                <div
                  className=""
                  style={{
                    maxHeight: "220px",
                    overflowY: "auto",
                  }}
                >
                  {availability.map((item, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-[300px_100px_100px] items-center border-b border-gray-200 text-[16px] mb-2 py-2"
                    >
                      <span className="w-[300px] font-medium text-[16px] text-[#707070] whitespace-normal">
                        {item.repoName}
                      </span>

                      <span className="w-[100px] text-left text-[#020040] font-semibold">
                        Q: {item.quantity}
                      </span>

                      <span className="w-[100px] text-left text-[#020040] font-semibold">
                        R: {item.reserved}
                      </span>
                    </div>

                  ))}
                </div>
              ) : (
                <p className="text-gray-600"></p>
              )}
            </div>





          </div>
        </div>
      </div>
      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>

  );
};

export default ProductPopup;
